import {
  MatLegacySnackBarHorizontalPosition as MatSnackBarHorizontalPosition,
  MatLegacySnackBarVerticalPosition as MatSnackBarVerticalPosition,
} from '@angular/material/legacy-snack-bar';
import { environment } from '../../../environments/environment';
import { CONSTANTSENDPOINTS } from './constants-urls/constants-endpoints';

export enum TIME_PERIODS {
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
  BIWEEKLY = 'biweekly',
  DAILY = 'daily',
}
export class CONSTANTS {
  //Safari push notification
  public static readonly API_REST_IOS_NOTIFICATION =
    environment.iosNotificationAPI.baseUrl + environment.iosNotificationAPI.prefixPackage;
  public static readonly API_REST_IOS_TOPICS =
    environment.iosNotificationAPI.messagingUrl + environment.iosNotificationAPI.prefixTopics;
  public static readonly API_REST_IOS_SEND_NOTIFICATION =
    environment.iosNotificationAPI.messagingUrl + environment.iosNotificationAPI.prefixSend;

  // HIPATIA SERVICES
  public static readonly API_REST_COMPONENTS_USING_SEGMENT_URL_NEST = `${environment.hipatiaServicesApi}segment/componentsUsingSegment`;
  public static readonly API_REST_UPDATE_SITES_TYPE_WALL = `${environment.hipatiaServicesApi}trigger/updateSitesTypeWall`;
  public static readonly API_REST_UPDATE_SITES_SCRIPT_FEATURES = `${environment.hipatiaServicesApi}features/:mediaId`;
  public static readonly API_REST_UPDATE_MEDIAS_TYPE_WALL = `${environment.hipatiaServicesApi}trigger/updateMediasTypeWall`;
  public static readonly UPLOAD_IMAGE_URL = `${environment.hipatiaServicesApi}image/upload`;
  // METRICS
  public static readonly API_REST_REAL_TIME_CONCURRENT_USERS_URL =
    environment.realTimeAPI.baseURL + environment.realTimeAPI.concurrentUsersPath;
  public static readonly API_REST_REAL_TIME_CONCURRENT_USERS_URL_BY_DEVICE =
    environment.realTimeAPI.baseURL + environment.realTimeAPI.concurrentUsersPathDevice;
  public static readonly API_REST_REAL_TIME_CONCURRENT_PAGE_VIEWS_URL =
    environment.realTimeAPI.baseURL + environment.realTimeAPI.concurrentPageViewsPath;
  public static readonly API_REST_REAL_TIME_CONCURRENT_PAGE_VIEWS_URL_BY_DEVICE =
    environment.realTimeAPI.baseURL + environment.realTimeAPI.concurrentPageViewsPathDevice;

  // **********SEGMENTS***********
  public static readonly SEGMENTS_TYPES_NAMES = ['histórico', 'real time', 'importado'];

  public static readonly API_REST_SEGMENTS_GENERATOR_URL =
    environment.segmentsAPI.baseURL + environment.segmentsAPI.prefixGenerator;

  // IMPORTED SEGMENTS
  public static readonly API_RULES_OPERATION_UPDATE_IMPORTED_SEGMENT_COMPONENTS =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.updateImportedSegmentComponents;

  // HISTORICAL SEGMENTS
  public static readonly API_REST_SEGMENTS_HISTORICAL_URL =
    environment.segmentsAPI.baseURL +
    environment.segmentsAPI.prefixGenerator +
    environment.segmentsAPI.prefixHistorical;
  public static readonly API_SEGMENT_AUTHOR = environment.segmentsAPI.prefixAuthor;
  public static readonly API_SEGMENT_LAYOUT = environment.segmentsAPI.prefixLayout;
  public static readonly API_RULES_SEGMENT_USERS =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalUsers;
  public static readonly API_RULES_SEGMENT_CREATE =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalCreate;
  public static readonly API_RULES_SEGMENT_UPDATE =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalUpdate;
  public static readonly API_RULES_SEGMENT_DELETE =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalDelete;
  public static readonly API_RULES_OPERATION_UPDATE_SEGMENT_COMPONENTS =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.updateHistoricalSegmentComponents;
  public static readonly API_RULES_OPERATION_SEGMENT_USERS =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalOperationUsers;
  public static readonly API_RULES_OPERATION_SEGMENT_CREATE =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalOperationCreate;
  public static readonly API_RULES_OPERATION_SEGMENT_UPDATE =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalOperationUpdate;
  public static readonly API_RULES_OPERATION_SEGMENT_DELETE =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentHistoricalOperationDelete;
  public static readonly API_RULES_SEGMENTS =
    environment.rulesegmentAPI.baseURL + environment.rulesegmentAPI.segmentsHistorical;
  public static readonly API_RULES_SEGMENTS_APPS =
    environment.rulesegmentAPI.baseURL + '/api/segment/historical/segments/app/:mediaId';

  public static readonly PUSH_CONFIG_UPLOAD = environment.fcmCredentials.baseURL + environment.fcmCredentials.upload;
  public static readonly PUSH_CONFIG_UPLOAD_APP =
    environment.fcmCredentials.baseURL + environment.fcmCredentials.uploadApp;

  // REALTIME SEGMENTS
  public static readonly API_REST_SEGMENTS_REALTIME_URL =
    environment.segmentsAPI.baseURL + environment.segmentsAPI.prefixGenerator + environment.segmentsAPI.prefixRealTime;

  public static readonly API_REST_UPDATE_TRIGGER_VERSION =
    environment.triggerVersion.baseUrl + 'trigger/version/:mediaId';

  public static readonly API_REST_UPDATE_SEGMENT_VERSION =
    environment.triggerVersion.baseUrl + 'segment/version/:mediaId';

  public static readonly API_REST_DELETE_TRIGGER_APP = `${environment.prometeoAppsAPI}/v1/cache/trigger/:mediaId`;

  public static readonly API_REST_DELETE_REAL_TIME_SEGMENT_APP = `${environment.prometeoAppsAPI}/v1/cache/real-time-segment/:mediaId`;

  // Push Notification API URL

  public static readonly API_REST_PUSH_NOTIFICATION_URL =
    environment.pushNotificationAPI.baseUrl + environment.pushNotificationAPI.prefixPush;
  public static readonly API_SCHEDULE_CREATE =
    environment.scheduleNotification.baseUrl + environment.scheduleNotification.prefixSchedule;
  public static readonly API_SCHEDULE_UPDATE =
    environment.scheduleNotification.baseUrl + CONSTANTSENDPOINTS.scheduledNotification.prefixScheduleUpdate;
  public static readonly API_SCHEDULE_APP =
    environment.scheduleNotification.baseUrl + CONSTANTSENDPOINTS.scheduledNotification.prefixScheduleApp;
  public static readonly API_SCHEDULE_APP_DELETE =
    environment.scheduleNotification.baseUrl + CONSTANTSENDPOINTS.scheduledNotification.prefixScheduleDeleteApp;

  public static readonly PUSH_SHOW_TOPICS = environment.pushNotificationAPI.showTopics;
  public static readonly PUSH_UTM_SOURCE = 'hipatia-push-web';
  public static readonly PUSH_UTM_MEDIUM = 'Push Notifications';

  // Push notification credentials and scripts

  public static readonly API_REST_PUSH_NOTIFICATION_CREDENTIALS_SCRIPT_URL =
    environment.fcmCredentials.baseURL + environment.fcmCredentials.prefixNotification;

  public static readonly CLOUDFRONT_URL = environment.cloudfrontURL;
  public static readonly EMAIL_ACTIONS_URL = environment.emailActionsURL;

  public static readonly MAX_FILE_SIZE = 500000;

  public static readonly PROMETEO_WIDGETS_NORMAL_MODE: number = 0;
  public static readonly PROMETEO_WIDGETS_STICKY_BOTTOM_MODE: number = 1;
  public static readonly PROMETEO_WIDGETS_STICKY_TOP_MODE: number = 2;
  public static readonly PROMETEO_WIDGETS_SIDEBAR_MODE: number = 3;
  public static readonly PROMETEO_WIDGETS_NORMAL_MODE_LITERAL: string = 'Normal';
  public static readonly PROMETEO_WIDGETS_STICKY_BOTTOM_MODE_LITERAL: string = 'Sticky bottom';
  public static readonly PROMETEO_WIDGETS_STICKY_TOP_MODE_LITERAL: string = 'Sticky top';
  public static readonly PROMETEO_WIDGETS_SIDEBAR_MODE_LITERAL: string = 'Sidebar';

  public static readonly PROMETEO_ARTICLE_ACCESS_TYPE_LIST = ['suscripcion', 'registro', 'abierto', 'vacio'];

  public static readonly PROMETEO_TRIGGERS_HOME_LAYOUT: number = 1;
  public static readonly PROMETEO_TRIGGERS_ARTICLE_LAYOUT: number = 2;
  public static readonly PROMETEO_TRIGGERS_ARTICLE_LAYOUT_LITERAL: string = 'Artículo';
  public static readonly PROMETEO_TRIGGERS_HOME_LAYOUT_LITERAL: string = 'Home';

  public static readonly PROMETEO_TRIGGERS_MODAL_TYPE: number = 1;
  public static readonly PROMETEO_TRIGGERS_STICKY_TOP_TYPE: number = 2;
  public static readonly PROMETEO_TRIGGERS_STICKY_BOTTOM_TYPE: number = 3;
  public static readonly PROMETEO_TRIGGERS_SIDEBAR_TYPE: number = 4;
  public static readonly PROMETEO_TRIGGERS_PUSH_TYPE: number = 5;
  public static readonly PROMETEO_TRIGGERS_NONE_TYPE: number = 7;
  public static readonly PROMETEO_TRIGGERS_BOX_TYPE: number = 8;
  public static readonly PROMETEO_TRIGGERS_MODAL_TYPE_LITERAL: string = 'Modal';
  public static readonly PROMETEO_TRIGGERS_STICKY_TOP_TYPE_LITERAL: string = 'Sticky top';
  public static readonly PROMETEO_TRIGGERS_STICKY_BOTTOM_TYPE_LITERAL: string = 'Sticky bottom';
  public static readonly PROMETEO_TRIGGERS_SIDEBAR_TYPE_LITERAL: string = 'Sidebar';
  public static readonly PROMETEO_TRIGGERS_PUSH_TYPE_PLURAL_LITERAL: string = 'Notificaciones push';
  public static readonly PROMETEO_TRIGGERS_NONE_TYPE_LITERAL: string = 'Ninguno';
  public static readonly PROMETEO_TRIGGERS_ALL_TYPE_LITERAL: string = 'Todos';
  public static readonly PROMETEO_TRIGGERS_TRIGGER_TYPE_PLURAL_LITERAL: string = 'Activadores';
  public static readonly PROMETEO_TRIGGERS_BOX_TYPE_LITERAL: string = 'Box';

  public static readonly PROMETEO_SCHEDULES_MESSAGE_MANUAL_TYPE: number = 1;
  public static readonly PROMETEO_SCHEDULES_MESSAGE_DYNAMIC_TYPE: number = 2;
  public static readonly PROMETEO_SCHEDULES_MESSAGE_MANUAL_TYPE_LITERAL: string = 'Manual';
  public static readonly PROMETEO_SCHEDULES_MESSAGE_DYNAMIC_TYPE_LITERAL: string = 'Dinámico';

  public static readonly PROMETEO_SCHEDULES_NOW_TYPE: number = 1;
  public static readonly PROMETEO_SCHEDULES_SCHEDULED_TYPE: number = 2;
  public static readonly PROMETEO_SCHEDULES_PERIODICALLY_TYPE: number = 3;
  public static readonly PROMETEO_SCHEDULES_NOW_TYPE_LITERAL: string = 'Inmediato';
  public static readonly PROMETEO_SCHEDULES_SCHEDULED_TYPE_LITERAL: string = 'Planificado';
  public static readonly PROMETEO_SCHEDULES_PERIODICALLY_TYPE_LITERAL: string = 'Periódico';

  public static readonly PROMETEO_SCHEDULES_ENDPOINT_MOSTREAD_TYPE: number = 1;
  public static readonly PROMETEO_SCHEDULES_ENDPOINT_MOSTREAD_TYPE_LITERAL: string = 'Lo más Leído';
  public static readonly PROMETEO_SCHEDULES_ENDPOINT_MOSTRECENT_TYPE: number = 2;
  public static readonly PROMETEO_SCHEDULES_ENDPOINT_MOSTRECENT_TYPE_LITERAL: string = 'Lo más Reciente';

  public static readonly PROMETEO_CREATE_ACTION_TYPE: number = 1;
  public static readonly PROMETEO_UPDATE_ACTION_TYPE: number = 2;
  public static readonly PROMETEO_DELETE_ACTION_TYPE: number = 3;

  // TODO refactor notification entities, remember cloud function that generates these.
  public static readonly PROMETEO_WIDGET_ENTITY_TYPE: number = 1;
  public static readonly PROMETEO_WIDGET_ENTITY_TYPE_LITERAL: string = 'widget';
  public static readonly PROMETEO_DATASOURCE_ENTITY_TYPE: number = 2;
  public static readonly PROMETEO_DATASOURCE_ENTITY_TYPE_LITERAL: string = 'datasource';
  public static readonly PROMETEO_WIDGET_TEMPLATE_ENTITY_TYPE: number = 3;
  public static readonly PROMETEO_TRIGGER_ENTITY_TYPE: number = 4;
  public static readonly PROMETEO_TRIGGER_ENTITY_TYPE_LITERAL: string = 'trigger';
  public static readonly PROMETEO_SEGMENT_ENTITY_TYPE: number = 5;
  public static readonly PUSH_SUBSCRIPTION_ENTITY_TYPE: number = 6;
  public static readonly PUSH_SUBSCRIPTION_ENTITY_TYPE_LITERAL: string = 'push subscription';
  public static readonly PROMETEO_TRIGGER_TEMPLATE_ENTITY_TYPE: number = 9;
  public static readonly PROMETEO_PUSH_SUBSCRIPTION_TEMPLATE_ENTITY_TYPE: number = 10;
  public static readonly PROMETEO_TEST_AB_ENTITY_TYPE: number = 12;
  public static readonly PROMETEO_TEST_AB_ENTITY_TYPE_LITERAL: string = 'test-ab';
  public static readonly PROMETEO_TEST_AB_WIDGETS_ENTITY_TYPE: number = 13;
  public static readonly PROMETEO_TEST_AB_WIDGETS_ENTITY_TYPE_LITERAL: string = 'test-ab widgets';
  public static readonly PROMETEO_OPERATION_SEGMENT_ENTITY_TYPE: number = 14;
  public static readonly PROMETEO_OPERATION_SEGMENT_ENTITY_TYPE_LITERAL: string = 'operation segment';
  public static readonly PROMETEO_THALIA_AUDIO_TRANSCRIPT_ENTITY_TYPE: number = 15;

  public static readonly MONDAY: number = 1;
  public static readonly MONDAY_LITERAL: string = 'Lunes';
  public static readonly TUESDAY: number = 2;
  public static readonly TUESDAY_LITERAL: string = 'Martes';
  public static readonly WEDNESDAY: number = 3;
  public static readonly WEDNESDAY_LITERAL: string = 'Miércoles';
  public static readonly THURSDAY: number = 4;
  public static readonly THURSDAY_LITERAL: string = 'Jueves';
  public static readonly FRIDAY: number = 5;
  public static readonly FRIDAY_LITERAL: string = 'Viernes';
  public static readonly SATURDAY: number = 6;
  public static readonly SATURDAY_LITERAL: string = 'Sábado';
  public static readonly SUNDAY: number = 7;
  public static readonly SUNDAY_LITERAL: string = 'Domingo';

  // Period frecuency
  public static readonly TIME_PERIOD_FRECUENCY = [
    {
      key: TIME_PERIODS.MONTHLY,
      literal: 'Mensual',
    },
    {
      key: TIME_PERIODS.WEEKLY,
      literal: 'Semanal',
    },
    {
      key: TIME_PERIODS.BIWEEKLY,
      literal: 'Quincenal',
    },
    {
      key: TIME_PERIODS.DAILY,
      literal: 'Diario',
    },
  ];

  // Days of week config
  public static readonly DAYS_OF_WEEK_CRON_CONFIG = [
    {
      unixCronKey: 'sun',
      literal: 'Domingo',
    },
    {
      unixCronKey: 'mon',
      literal: 'Lunes',
    },
    {
      unixCronKey: 'tue',
      literal: 'Martes',
    },
    {
      unixCronKey: 'wed',
      literal: 'Miércoles',
    },
    {
      unixCronKey: 'thu',
      literal: 'Jueves',
    },
    {
      unixCronKey: 'fri',
      literal: 'Viernes',
    },
    {
      unixCronKey: 'sat',
      literal: 'Sábado',
    },
  ];
  public static readonly FIRSTDAY_OF_MONTH = 1;
  public static readonly LASTDAY_OF_MONTH = 31;

  public static readonly COPY_OF = 'copia de ';

  public static readonly TYPE_XML = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

  //Trigger types priorities
  public static readonly TRIGGER_TYPE = 'Activador';
  public static readonly PUSH_SUBSCRIPTION_TYPE = 'Push Subscription';
  public static readonly TESTAB_TYPE = 'Test A/B';

  //Trigger types statistics
  public static readonly TRIGGER_TYPE_STATISTICS = 'Activador';
  public static readonly PUSH_NOTIFICATION_TYPE_STATISTICS = 'Notificación Push';
  public static readonly WIDGET_TYPE_STATISTICS = 'Widget';

  //Triggers types
  public static readonly PROMETEO_ALL_TYPE = 1;
  public static readonly PROMETEO_TRIGGERS_TYPE = 2;
  public static readonly PROMETEO_PUSH_SUBSCRIPTION_TYPE = 3;

  //EVENTS FUNCTIONS
  public static readonly SHOW_EVENT = 'TRIGGER_EVENTS.show()';
  public static readonly ACTION_EVENT = 'TRIGGER_EVENTS.action()';

  //TOKEN APPS
  public static readonly API_TOKEN_APPS_CREATE = environment.tokenApps.baseUrl + 'create';
  public static readonly API_TOKEN_APPS_ALL_TOKEN = environment.tokenApps.baseUrl;
  public static readonly API_TOKEN_APPS_UPDATE = environment.tokenApps.baseUrl + 'update';
  public static readonly API_TOKEN_APPS_DELETE = environment.tokenApps.baseUrl + 'delete';
  public static readonly API_TOKEN_APPS_DELETE_CREDENTIALS = `${environment.tokenApps.baseUrl}delete/credentials`;
  //USER FUNCTIONS
  public static readonly API_FUNCTION_DELETE_USER_FROM_AUTH =
    environment.cloudFunctionsAPI + '/deleteCompleteUser/user/:userId';

  //INFO ICONS COLORS
  public static readonly PRIMARY_COLOR = '#1B55E3';
  public static readonly RED_COLOR = 'red';
  public static readonly ORANGE_COLOR = 'orange';

  //SITE TYPES
  public static readonly SITE_WEB: string = 'web';
  public static readonly SITE_APP: string = 'app';

  //MONTHS INTERVAL IN STATISTICS
  public static readonly STATISTICS_MONTH_INTERVAL: number = 4;
  public static readonly STATISTICS_ONE_MONTH_INTERVAL: number = 1;

  public static readonly STATISTICS_DAY_INTERVAL: number = 7;

  //FIREBASE AUTHENTICATION ACTIONS
  public static readonly RESET_PASSWORD_MODE: string = 'resetPassword';
  public static readonly RECOVER_EMAIL_MODE: string = 'recoverEmail';
  public static readonly VERIFY_EMAIL_MODE: string = 'verifyEmail';

  //USER ACCESS TYPES
  public static readonly USER_ACCESS_TYPE_MEDIAS = 'medias';

  //Numeric

  public static readonly INPUT_NUMBER_VALUE_MIN: number = 0;

  public static readonly AES_KEY = 'p*c.s¡a2020';

  public static readonly FIRESTORE = {
    COLLECTIONS: {
      ADVERTISERS: 'advertisers',
    },
    KEYS: {
      MEDIA: 'mediaId',
      ACTIVE: 'active',
    },
  };

  //Shared medias
  public static readonly SHARED_MEDIAS_SINGULAR = 'otro';
  public static readonly SHARED_MEDIAS_PLURAL = 'otros';
  public static readonly TRIGGER_ACTIVATION_URL =
    environment.hipatiaServicesApi + 'trigger/cache-processor/activate-trigger';
  public static readonly TRIGGER_INACTIVATION_URL =
    environment.hipatiaServicesApi + 'trigger/cache-processor/inactivate-trigger';
  public static readonly TRIGGER_PUNCTUAL_TASK_URL = environment.hipatiaServicesApi + 'trigger/task-processor/punctual';
  public static readonly TRIGGER_PERIODIC_TASK_URL = environment.hipatiaServicesApi + 'trigger/task-processor/periodic';
  public static readonly TRIGGER_PURGE_SCHEDULE_JOBS_URL =
    environment.hipatiaServicesApi + 'trigger/schedule-processor/purge';
  public static readonly TRIGGER_TAG_TASK = 'task';
  public static readonly PUSH_SUBSCRIPTIONS_COLLECTION = 'push-subscriptions';
  public static readonly TRIGGERS_COLLECTION = 'triggers';

  public static readonly CSS_LOADER = `
    .accept-loader { width: :wpx;height: :hpx;border-radius: 50%;display: inline-block;border-top: 3px solid :hexacolor;border-right: 3px solid transparent;box-sizing: border-box;animation: rotation 1s linear infinite;} @keyframes rotation { 0% { transform: rotate(0deg);}100% { transform: rotate(360deg);}}`;
}

export const HYPHENATED_PLACEHOLDER = '-';
export const EMPTY_PLACEHOLDER = '';

export enum FEATURE {
  THALIA,
}

export const SNACK_BAR = {
  CONFIGURATION: {
    horizontalPosition: 'right' as MatSnackBarHorizontalPosition,
    verticalPosition: 'bottom' as MatSnackBarVerticalPosition,
    duration: 5000,
  },
  STYLE: {
    POSITION: 'fixed',
    LEFT: '0',
    TOP: '0',
    OPACITY: '0',
  },
};

export const ASYNC_VALIDATOR_PULSE = 500;
export const QUERYS_DISJUNCTIVE_LIMIT = 30;

//TODO revisar si se requiere aún mas especificidad, por ahora un slug puede ser '-----------' por ejemplo
export const SLUG_PATTERN = {
  ACCEPTED: new RegExp(/^[a-z0-9-]+$/),
  REJECTED: new RegExp(/[^a-z0-9-]/g),
  REPLACE: '-',
};
